import { render, staticRenderFns } from "./EmbedStep4.vue?vue&type=template&id=0f9f10ea&scoped=true&"
import script from "./EmbedStep4.vue?vue&type=script&lang=js&"
export * from "./EmbedStep4.vue?vue&type=script&lang=js&"
import style0 from "./EmbedStep4.vue?vue&type=style&index=0&id=0f9f10ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9f10ea",
  null
  
)

export default component.exports